import {
    SERVICE_COMMENTS_LOADING,
    SERVICE_COMMENTS_FAILED,
    SERVICE_COMMENTS_SUCCESS
    } from "../types"
    
    const initialState = {
      loading: false,
      error: false,
      message: null,
    }
    
    export default function (state = initialState, action) {
      switch (action.type) {
        case SERVICE_COMMENTS_LOADING:
          return {
            ...state,
            loading: true,
            error: false,
            message: null,
          }
        case SERVICE_COMMENTS_FAILED:
          return {
            ...state,
            loading: false,
            error: true,
            message: action.payload,
          }
        case SERVICE_COMMENTS_SUCCESS:
          return {
            ...state,
            loading: false,
            error: false,
            message: null,
          }
        default:
          return state
      }
    }